import { useState } from 'react';
import { useScoredCodes } from '@app/view-creator/Admin/QuestionnaireAdminViewCreator';

/** Runs the scored-codes link: whether its dialog is open, and the codes, loaded the first time it opens. */
export const useScoredCodesLinkController = () => {
  const [open, setOpen] = useState(false);
  const scoredCodesQuery = useScoredCodes(open);

  return {
    open,
    loading: scoredCodesQuery.isLoading,
    loadFailed: scoredCodesQuery.isError,
    questionnaires: scoredCodesQuery.data?.questionnaires ?? [],
    instruments: scoredCodesQuery.data?.instruments ?? [],
    handleOpen: () => setOpen(true),
    handleClose: () => setOpen(false),
  };
};
